module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Marvin Kistler wrote "), _c('em', [_vm._v("The Stranger Within")]), _vm._v(", published in 1995, about the two halves of the brain and how they function and relate to everyday life. In 2008, he wrote "), _c('em', [_vm._v("The War Between the Ego and You; The Internal Battles for Control of the Self")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("He has a B.S. degree in education from Miami University in Oxford, Ohio; a B.S. degree in electrical engineering from South Florida University; one year of graduate school at the University of Mississipi in psychology and a Silver Life Master at duplicate bridge. He also dabbles in stand-up comedy at a local comedy club.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0